/**
 * Awards winners archive: "Alla" and year buttons filter the editions in place.
 *
 * Markup: archive-award.php. All editions are in the page; a year button
 * hides the others. The choice goes to the hash (#vinnare-{slug}) so a year
 * can be linked and the back button works. No element has that id, so the
 * browser doesn't jump down the page on load.
 */

const HASH_PREFIX = '#vinnare-';

export default function initArchive(root) {
  const buttons = [...root.querySelectorAll('[data-archive-filter]')];
  const editions = [...root.querySelectorAll('[data-archive-edition]')];
  const list = root.querySelector('[data-archive-editions]');

  if (!buttons.length) {
    return;
  }

  const slugFromHash = () =>
    window.location.hash.startsWith(HASH_PREFIX)
      ? decodeURIComponent(window.location.hash.slice(HASH_PREFIX.length))
      : '';

  // An empty slug shows all editions; unknown slugs fall back to it.
  const show = (slug) => {
    const selected = editions.some((edition) => edition.dataset.archiveEdition === slug) ? slug : '';

    editions.forEach((edition) => {
      edition.hidden = selected !== '' && edition.dataset.archiveEdition !== selected;
    });

    // Year headings only in the "Alla" view (_awards-archive.scss).
    list.classList.toggle('awards-archive__editions--all', selected === '');

    buttons.forEach((button) => {
      button.setAttribute('aria-pressed', String(button.dataset.archiveFilter === selected));
    });

    return selected;
  };

  root.addEventListener('click', (event) => {
    const button = event.target.closest('[data-archive-filter]');

    if (!button || button.getAttribute('aria-pressed') === 'true') {
      return;
    }

    const selected = show(button.dataset.archiveFilter);
    const url = selected ? HASH_PREFIX + encodeURIComponent(selected) : window.location.pathname + window.location.search;

    window.history.pushState(null, '', url);
  });

  window.addEventListener('popstate', () => show(slugFromHash()));

  const initial = show(slugFromHash());

  // A linked year may sit beyond the visible part of the scrolling button row.
  if (initial) {
    buttons
      .find((button) => button.dataset.archiveFilter === initial)
      .scrollIntoView({ block: 'nearest', inline: 'nearest' });
  }
}
